import { FormInstance, message } from 'antd';
import { NavigateFunction } from 'react-router-dom';
import { contentProviderService } from '../services/contentProviderService';

interface ContentProviderEditHandlersHook {
  form: FormInstance;
  navigate: NavigateFunction;
  id: string;
}

interface ContentProviderEditHandlersReturn {
  onFinish: () => Promise<void>;
}

export const getContentProviderEditHandlers = ({
  form,
  navigate,
  id,
}: ContentProviderEditHandlersHook): ContentProviderEditHandlersReturn => {
  const onFinish = async (): Promise<void> => {
    const loadingMessage = message.loading('Updating...', 0);
    try {
      const values = await form.validateFields();
      await contentProviderService.update(Number(id), values);
      loadingMessage();
      navigate('/content-provider');
    } catch (error) {
      loadingMessage();
      message.error('Failed to update : ' + error);
    }
  };

  return {
    onFinish,
  };
};
